import * as actionTypes from "../../Action/actionTypes";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 12/3/20
 * Time: 11:12 AM
 */

const initialState = {
  // currentObj: null, //{userId:selectedObj.userId,branchId:3}
  branchId: 0,
  userId: 0,
  date: null,
  idList: [],
  visitorList: [
    // {
    //   "error_code": 710,
    //   "message": "This visitor already checked-in. Please use that card ( CEY_426 ) to another check-in",
    //   "card": {
    //     "cardId": 378,
    //     "did": "426",
    //     "uid": null,
    //     "passId": "CEY_426",
    //     "regDate": "2020-09-24 11:49:37",
    //     "issueDate": "2020-09-24 11:49:37",
    //     "status": "RESERVED",
    //     "allocated": "",
    //     "cardIndex": 0,
    //     "branch": {
    //       "branchId": 1,
    //       "name": "Ceyentra Panadura Branch 01",
    //       "location": "Ceyentra Technologies (Pvt) Ltd, Road, Panadura, Sri Lanka",
    //       "address": "17A, Thanthirimulla Road, Panadura",
    //       "buildingCount": 2
    //     }
    //   },
    //   "visitor": {
    //     "visitBefore": true,
    //     "visitor": {
    //       "userId": 70077351,
    //       "firstName": "T",
    //       "lastName": "A",
    //       "identificationType": "Driving Licence",
    //       "identificationValue": "1234567",
    //       "mobile": "0778533933",
    //       "email": null,
    //       "companyName": "-",
    //       "title": "Mr",
    //       "gender": "Male",
    //       "remarkColour": null,
    //       "remark": null,
    //       "photoPath": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUDJmfXIkhAjgoMiJph0X1MFOoTt-L-Slaow&usqp=CAU",
    //       "tagRemark": false
    //     }
    //   }
    // },
    // {
    //   "visitBefore": true,
    //   "visitor": {
    //     "userId": 746532,
    //     "firstName": "Tharindu",
    //     "lastName": "Athukorala",
    //     "identificationType": "NIC",
    //     "identificationValue": "962631444v",
    //     "mobile": "0778533900",
    //     "email": "tharinduathukorala1@gmail.com",
    //     "companyName": "Ceyentra Technologies",
    //     // "title": "Mr",
    //     "gender": "Male",
    //     "remarkColour": null,
    //     "remark": null,
    //     "photoPath": "https://visitortags-test.dialog.lk/resources/visitor/images/7dd1300d-a57c-4c23-8be4-81104d24b7e5.jpeg",
    //     "tagRemark": false
    //   },
    // },
  ],
};

const reducer=(state=initialState,action)=>{
  switch(action.type){
    case actionTypes.SOCKET_SELECT_BRANCH_VISITOR:
      return {
        ...state,
        userId: action.value,
      };
    case actionTypes.SOCKET_BRANCH_ID:
      return {
        ...state,
        branchId: action.value,
      };
    case actionTypes.SOCKET_FETCH_ALL_BRANCH_VISITORS:
      return {
        ...state,
        visitorList: action.value,
      };
    case actionTypes.SOCKET_DELETE_VISITORS_ID_LIST:
      return {
        ...state,
        idList: action.value,
      };
    case actionTypes.SOCKET_ADD_NEW_BRANCH_VISITOR:
      let {visitorList} = state;

      let customResp = action.value;
      if(customResp.userStatus === ADD && customResp.visitors && customResp.visitors.length !== 0){
        customResp.visitors.map((obj,index)=>{
          visitorList.push(obj);
        })
      }else if(customResp.userStatus === REMOVE && customResp.visitors && customResp.visitors.length !== 0) {
        customResp.visitors.map((obj,index)=>{
          let curIndex = visitorList.findIndex(visitor => (visitor.error_code === 710 ? visitor.visitor.visitor.userId : visitor.visitor.userId) === (obj.error_code === 710 ? obj.visitor.visitor.userId : obj.visitor.userId));
          if(curIndex !== -1 ) visitorList.splice(curIndex, 1);
        })
      }

      return {
        ...state,
        date: new Date().getTime(),
        visitorList,
      };

    default:
      return state;
  }
};

let ADD = "ADD";
let REMOVE = "REMOVE";

export default reducer;
